<template>
  <div class="mt-md">
    <h1 class="font-md blue-darker bold-medium mb-xs">{{ t('invoices.invoiceList') }}</h1>

    <div v-for="invoice in invoicesInPage" :key="`invoice-${invoice.id}`">
      <InvoiceCard
        :status="invoice.status"
        :code="invoice.code"
        :currency="invoice.currency"
        :grand-total="invoice.grandTotal"
        :id="invoice.id"
        :paid-at="invoice.paidAt"
      />
    </div>
    <div v-if="invoicesInPage.length > 0 && pagination.pages > pagination.page">
      <ion-infinite-scroll @ionInfinite="ionInfinite">
        <div class="gap-xs d-flex flex-column mt-xs">
          <SkeletonListItemCard :width="'100%'" :key="`invoice-page-loading-0`" />
          <SkeletonListItemCard :width="'100%'" :key="`invoice-page-loading-1`" />
          <SkeletonListItemCard :width="'100%'" :key="`invoice-page-loading-2`" />
          <SkeletonListItemCard :width="'100%'" :key="`invoice-page-loading-3`" />
        </div>
      </ion-infinite-scroll>
    </div>

    <div v-if="isLoading">
      <div class="gap-xs d-flex flex-column mt-xs">
        <SkeletonListItemCard :width="'100%'" :key="`invoice-loading-0`" />
        <SkeletonListItemCard :width="'100%'" :key="`invoice-loading-1`" />
        <SkeletonListItemCard :width="'100%'" :key="`invoice-loading-2`" />
        <SkeletonListItemCard :width="'100%'" :key="`invoice-loading-3`" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { storeToRefs } from 'pinia';
  import { useBillingStore } from '@/stores/billing-store';
  import InvoiceCard from './InvoiceCard.vue';
  import { useInvoices } from '@/composables/useInvoices';
  import SkeletonListItemCard from '../loaders/SkeletonListItemCard.vue';
  import { InfiniteScrollCustomEvent, IonInfiniteScroll } from '@ionic/vue';

  const { t } = useI18n();

  const { invoicesInPage, isLoading, pagination } = storeToRefs(useBillingStore());
  const { getInvoicesList } = useInvoices();

  const ionInfinite = (ev: InfiniteScrollCustomEvent) => {
    getInvoicesList(pagination.value.page + 1);
    setTimeout(() => ev.target.complete(), 500);
  };

  const initialConfig = () => {
    getInvoicesList(1);
  };

  onMounted(() => {
    initialConfig();
  });
</script>

<style lang="css" scoped>
  .hide {
    width: 120px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
</style>
